const CANONICAL_POSITIVE_DECIMAL_ID = /^[1-9]\d*$/;

/**
 * Parse an exact Sportsnew odd_state_id without JavaScript coercion aliases.
 * Only an already-safe positive integer or its canonical decimal string is
 * accepted. Arrays, booleans, objects, whitespace, exponent and hex forms are
 * deliberately rejected because they can otherwise address another cart leg.
 */
export const parseSportsnewOddStateId = (value) => {
  if (typeof value === 'number') {
    return Number.isSafeInteger(value) && value > 0 ? value : null;
  }
  if (typeof value !== 'string' || !CANONICAL_POSITIVE_DECIMAL_ID.test(value)) {
    return null;
  }
  const parsed = Number(value);
  return Number.isSafeInteger(parsed) ? parsed : null;
};

export const sportsnewOddStateIdOf = (value) => {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return parseSportsnewOddStateId(
      value.oddStateId
        ?? value.odd_state_id
        ?? value.odds_id,
    );
  }
  return parseSportsnewOddStateId(value);
};

export default parseSportsnewOddStateId;
